// extracted by mini-css-extract-plugin
export default {"container":"TodoList_container__sM4zg"};